const resources = {
    lead: 'Ouvrez une session pour profiter de la *livraison standard GRATUITE* sur toutes les commandes.',
    signIn: 'Ouvrir une session',
    createAccount: 'Créer un compte',
    joinOurLoyaltyProgram: 'Adhérez à notre programme de fidélisation et de récompenses GRATUIT',
    getFreeShipping: '🚚 Expédition standard GRATUITE pour toutes les commandes',
    getFreeBirthdayGift: '🎂 Cadeau d’anniversaire GRATUIT avec tout achat de 25 $+',
    earnOnePointPerSpent: '👛 Accumulez 1 point par dollar dépensé',
    biLogoAltText: 'Beauty Insider',
    scanInStore: 'Balayer en magasin'
};

export default function getResource(label) {
    return resources[label];
}
